import { ActionType, getType } from 'typesafe-actions';

import { InitialState } from '../../initialState';
import { PrivateEntitlementsState, EntitlementWithKey } from '@tradingblock/types';
import { AdminEntitlementsAction, AdminEntitlementsActions } from '../../actions/admin/EntitlementsActions';
import { getEntityKey } from '../../utilities/entitlementsUtilities';
import { BlockActions } from '../../actions';

type Actions = AdminEntitlementsAction | ActionType<typeof BlockActions.removeBlock>;
export const privateEntitlementsReducer = (
  state = InitialState.private.entitlements,
  action: Actions
): PrivateEntitlementsState => {
  switch (action.type) {
    case getType(AdminEntitlementsActions.requestEntitlementUpdates): {
      const { blockId, page, pageSize } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            entitlements: [],
            isFetching: true,
            error: undefined,
            total: 0,
            page,
            pageSize,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.receiveEntitlementUpdates): {
      const { response, blockId } = action.payload;
      const pendingEntitlementRequests = response && response.data ? response.data : [];
      const total = response && response.total ? response.total : 0;
      const pendingEntitlementRequestsWithEntityKey = pendingEntitlementRequests.map(
        (pendingEntitlementRequest): EntitlementWithKey => ({
          ...pendingEntitlementRequest,
          entityKey: getEntityKey(pendingEntitlementRequest),
        })
      );

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            entitlements: pendingEntitlementRequestsWithEntityKey,
            isFetching: false,
            total,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.errorEntitlementUpdates): {
      const { blockId, error } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            entitlements: [],
            page: 0,
            pageSize:
              (state.entitlementDataByBlockId &&
                state.entitlementDataByBlockId[blockId] &&
                state.entitlementDataByBlockId[blockId].pageSize) ||
              10,
            isFetching: false,
            total: 0,
            error,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.setEntitlementsPage): {
      const { blockId, page } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            page,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.setEntitlementsPageSize): {
      const { blockId, pageSize } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            pageSize,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.setSelectedEntitlementId): {
      const { blockId, entitlementId } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            selectedEntitlementId: entitlementId,
          },
        },
      };
    }
    case getType(AdminEntitlementsActions.clearSelectedEntitlementId): {
      const { blockId } = action.payload;

      return {
        ...state,
        entitlementDataByBlockId: {
          ...state.entitlementDataByBlockId,
          [blockId]: {
            ...(state.entitlementDataByBlockId && state.entitlementDataByBlockId[blockId]),
            selectedEntitlementId: undefined,
          },
        },
      };
    }
    case getType(BlockActions.removeBlock): {
      const blockId = action.payload;

      let updatedEntitlementDataByBlockId = state.entitlementDataByBlockId
        ? { ...state.entitlementDataByBlockId }
        : null;

      if (updatedEntitlementDataByBlockId) {
        delete updatedEntitlementDataByBlockId[blockId];

        if (Object.keys(updatedEntitlementDataByBlockId).length === 0) {
          updatedEntitlementDataByBlockId = null;
        }
      }

      return {
        ...state,
        entitlementDataByBlockId: updatedEntitlementDataByBlockId,
      };
    }
    default: {
      return state;
    }
  }
};
